import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
`;

export const FilterInputStyle = styled.input`
    width: 100%;
    padding: 8px;
    margin-bottom: 16px;
`;

export const HighlightedText = styled.span`
    background-color: #ffeb3b;
`;

export const ListItem = styled.div`
    padding: 2px 4px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    &:hover {
        background-color: #f5f5f5;
    }
    &.is-selected {
        background-color: #e0e0e0;
    }
`;

export const TradeInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const CategoryName = styled.span`
    font-size: 0.9em;
    color: #666;
    margin-top: 0.25rem;
`;

export const ChartererName = styled.span`
    text-align: right;
`;
